export const searchParamsToString: (params: string[] | null) => string = (params) => {
    return params?.sort().join(',') || '';
};

/**
 * updateUrlSearchParams
 * @type string
 */
export const updateUrlSearchParams: (searchParams: Record<string, string[]>) => string = (searchParams) => {
    const params = new URLSearchParams(window.location.search);

    // update params sent in input
    for (const key in searchParams) {
        const value = searchParamsToString(searchParams[key as keyof typeof searchParams] || []);

        // update or delete
        value === '' ? params.delete(key) : params.set(key, value);
    }

    return params.toString() ? `${window.location.pathname}?${params.toString()}` : window.location.pathname;
};
